import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable({
  providedIn: 'root'
})
export class OrderCommentTagsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readOrderCommentTag(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_CUSTOMER_COMMENT_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readOrderCommentTags(): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_CUSTOMER_COMMENT_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject('/order_comment_tags')
    );
  }
}
